import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema } from './types/businessInformation';

const timeFormat = /^(?:[01]\d|2[0-3]):[0-5]\d$/;

export const THEATER_CONTENT_PATH = 'licenses.steps.businessInformation.forms.theater';

export const workOptionSchema = z.object({
  workTitle: z.string().min(1, { message: `workTitle.validation.required` }),
  composer: z.string().min(1, { message: `composer.validation.required` }),
  workNumber: z
    .string()
    .optional()
    .refine(v => !v || /^\d{5,8}$/.test(v), {
      message: `workNumber.validation.length`,
    }),
  usageDuration: z
    .string()
    .min(1, { message: `usageDuration.validation.required` })
    .regex(timeFormat, { message: `usageDuration.validation.format` }),
});

export type WorkOption = z.infer<typeof workOptionSchema>;

export const theaterBusinessInformationSchema = BasicBusinessInformationSchema.extend({
  works: z.array(workOptionSchema),
});

export type TheaterBusinessInformation = z.infer<typeof theaterBusinessInformationSchema>;

export const createTheaterBusinessInformationDefaults = (): z.infer<typeof theaterBusinessInformationSchema> => ({
  licenseCode: LicenseTypes.Theater,
  works: [],
});
